export default {
      id: "link-icon-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "sprite.svg#link-icon",
      toString: function () {
        return this.url;
      }
    }